import * as React from "react";
import { EXPERIENCE, InsuranceType } from "../../constants";
import { PHASE } from "../../routeConfig";
import { NOT_INSURED_ISSUER_SLUG } from "../../lib/constants";
import { PivotReason } from "./applicantSlice";
import useAppSelector from "../../hooks/useAppSelector";
import useCanShowMidFunnelAds from "../configuration/useCanShowMidFunnelAds";
import useConnectEnabled from "../feature-flags/hooks/useConnectEnabled";
import useIsFlagOn from "../feature-flags/hooks/useIsFlagOn";
import useIsSupportedIssuer from "../../hooks/useIsSupportedIssuer";
import useUnlinkedApplicationEntryRoute from "../unlinked-application/useUnlinkedApplicationEntryRoute";
export default function useSelectedIssuerNextRoute(issuerType) {
    if (issuerType === void 0) { issuerType = "auto"; }
    var canShowMidFunnelAds = useCanShowMidFunnelAds();
    var currentIssuer = useAppSelector(function (state) { return state.applicant.currentIssuer; });
    var _a = useAppSelector(function (state) { return state.configuration; }), enableFormExperience = _a.enableFormExperience, isSavvyWidget = _a.isSavvyWidget, experience = _a.experience, skipQualificationQuestions = _a.skipQualificationQuestions;
    var isSupportedIssuer = useIsSupportedIssuer();
    var autoUnlinkedEntryRoute = useUnlinkedApplicationEntryRoute(InsuranceType.Auto);
    var homeUnlinkedEntryRoute = useUnlinkedApplicationEntryRoute(InsuranceType.Home);
    var isConnectEnabled = useConnectEnabled();
    var isIssuerPageFirst = useIsFlagOn("unlinkedApplication_issuerPageFirst_frontend");
    var isPremiumEnabled = useIsFlagOn("unlinkedApplication_premiumEnabled_frontend");
    var isBundleAutoFromHome = useAppSelector(function (state) {
        return state.applicant.bundlePivotReason === PivotReason.BundleAutoFromHome;
    });
    var isPrefillUser = useAppSelector(function (state) { return state.configuration.experience === EXPERIENCE.PREFILL; });
    var unlinkedEntries = {
        auto: autoUnlinkedEntryRoute,
        home: homeUnlinkedEntryRoute,
    };
    var selectedIssuer = currentIssuer[issuerType];
    var unlinkedEntry = unlinkedEntries[issuerType];
    var qualificationRoutes = {
        auto: PHASE.HAVE_LOGIN,
        home: PHASE.HOME_HAVE_LOGIN,
    };
    var credentialsRoutes = {
        auto: PHASE.ENTER_CREDENTIALS,
        home: PHASE.HOME_ENTER_CREDENTIALS,
    };
    var credentialsRoute = credentialsRoutes[issuerType];
    var qualificationRoute = qualificationRoutes[issuerType];
    var skipConnectConsent = false;
    return React.useCallback(function getSelectedIssuerNextRoute(issuerOverride) {
        var issuer = issuerOverride || selectedIssuer;
        if (!issuer || !issuer.id) {
            return;
        }
        var id = issuer.id;
        if (isBundleAutoFromHome) {
            return unlinkedEntry;
        }
        if (!isIssuerPageFirst || isPrefillUser) {
            return isPremiumEnabled
                ? PHASE.UNLINKED_APPLICATION_AUTO_PAYMENT_PERIOD
                : PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER_ADDRESS;
        }
        if (id === NOT_INSURED_ISSUER_SLUG) {
            return enableFormExperience
                ? unlinkedEntry
                : canShowMidFunnelAds
                    ? PHASE.MID_FUNNEL_ADS_NOT_INSURED
                    : PHASE.UNQUALIFIED;
        }
        if (!isSupportedIssuer(issuer)) {
            if (isSavvyWidget) {
                return enableFormExperience
                    ? unlinkedEntry
                    : canShowMidFunnelAds
                        ? PHASE.MID_FUNNEL_ADS_UNSUPPORTED_ISSUER
                        : PHASE.UNSUPPORTED_ISSUER;
            }
            return PHASE.UNSUPPORTED_ISSUER;
        }
        if (isSavvyWidget &&
            (experience === EXPERIENCE.UNLINKED || !isConnectEnabled)) {
            return unlinkedEntry;
        }
        if (skipConnectConsent && skipQualificationQuestions) {
            return credentialsRoute;
        }
        return skipQualificationQuestions ? PHASE.DISCLAIMER : qualificationRoute;
    }, [
        skipConnectConsent,
        canShowMidFunnelAds,
        enableFormExperience,
        experience,
        isSavvyWidget,
        selectedIssuer,
        skipQualificationQuestions,
        unlinkedEntry,
        isSupportedIssuer,
        qualificationRoute,
        credentialsRoute,
        isConnectEnabled,
        isIssuerPageFirst,
        isPremiumEnabled,
        isBundleAutoFromHome,
        isPrefillUser,
    ]);
}
